import React, { memo, useEffect } from 'react'
import { FeedbackMessage } from 'components/marketplace/FeedbackMessage'
import PropTypes from 'prop-types'
import { Spinner } from 'transfix-ui/components/Spinner'
import { columnOrder } from 'apps/user/constants/shipments'
import { Pagination } from 'components/Pagination'
import { LegacyTableHeader as TableHeader } from 'components/atoms'
import { ShipmentRow, shipmentPropType } from './ShipmentRow'

export const Shipments = memo(
  ({
    dataLoadedForUserId,
    error,
    fetching,
    getShipments,
    hasNextPage,
    pageCount,
    shipments,
    sortField,
    sortOrder,
    userId,
  }) => {
    const getUserFilter = id => ({ parentUserId: id, usersType: 'parent_user' })
    const userFilter = getUserFilter(userId)

    useEffect(() => {
      if (userId && userId !== dataLoadedForUserId) {
        getShipments({ filters: { ...userFilter }, sortField: 'pickups', sortOrder: 'desc' })
      }
    }, [userId])
    const applyParams = params =>
      getShipments({ filters: { ...userFilter }, sortField, sortOrder, ...params })
    const applyPagination = ({ pageCount: toPage }) => applyParams({ pageCount: toPage })

    const ready = !fetching && !error
    return (
      <div className='row' data-test='shipments-tab-content'>
        {error && <FeedbackMessage message={error} type='error' />}
        <TableHeader
          columns={columnOrder}
          sortField={sortField}
          sortOrder={sortOrder}
          onSort={applyParams}
        />
        {fetching && <Spinner position='relative' />}
        {ready && (
          <>
            {!shipments.length ? (
              <p className='tc'>No shipments found.</p>
            ) : (
              shipments.map(shipment => <ShipmentRow key={shipment.id} shipment={shipment} />)
            )}
            <Pagination
              onClickHandler={applyPagination}
              params={{ pageCount }}
              hasNextPage={hasNextPage}
            />
          </>
        )}
      </div>
    )
  }
)

Shipments.propTypes = {
  userId: PropTypes.number.isRequired,
  shipments: PropTypes.arrayOf(shipmentPropType).isRequired,
  sortField: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  pageCount: PropTypes.number,
  hasNextPage: PropTypes.bool,
  fetching: PropTypes.bool,
  error: PropTypes.string,
  dataLoadedForUserId: PropTypes.number,
  getShipments: PropTypes.func,
}

Shipments.defaultProps = {
  pageCount: 0,
  hasNextPage: false,
  fetching: false,
  error: null,
  dataLoadedForUserId: null,
  getShipments: () => {},
}
